import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Path} from 'app/shared/path';
import {Mimetype} from '../../shared/mimetype';
import { FolderItem, ListDocumentResponse } from './folders.type';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';

declare let $: any;

@Component({
   selector: 'app-folders',
   templateUrl: './folders.component.html',
   styleUrls: ['./folders.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({height: 0})),
         state('expand', style({height: '*'})),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ],
   providers: [{
      // See: https://material.angular.io/components/checkbox/overview#click-action-config
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS, 
      useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions
  }]
})
export class FoldersComponent {
   @Input() tin: string;
   @Input() parent = '';
   @Input() path = '';
   @Input() parentPath = '';
   @Input() move = false;
   @Input() exportPath = false;
   @Input() selectFile = false;
   @Input() selectSite = false;
   @Input() select_id: any;
   @Input() selectedItems: any;
   @Input() checkFolder : any;
   @Input() typeName: any;
   @Input() drivePath: string;

   m = false;
   animationState = 'collapse';
   folders: FolderItem[];
   loading = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   givePath: string;
   isSelect: boolean;
   isSelectPath: boolean;
   @Output() selectPath = new EventEmitter<boolean>();
   @Output() checkSubFolder = new EventEmitter<boolean>();
   @Output() getPath = new EventEmitter<any>();
   constructor(private router: Router, private service: IdexService) {
   }

   toggle() {
      this.loading = true;
      let api = this.tin ? '/work/' + this.tin + '/folders' : '/folders';
      if (this.parent) {
         api += '?id=' + this.parent;
      }
      if (this.isExpanded()) {
         this.setAnimationState();
         this.loading = false;
      } else {
         if (!this.selectFile) {
            this.service.get(api)
               .subscribe((data: ListDocumentResponse) => {
                  this.folders = data.items.map(item => ({
                     ...item,
                     selected: false
                  }));
                  this.setAnimationState();
               }, error => {
                  this.error = error;
               }).add(() => {
               this.loading = false;
            });
         }

         if (this.selectFile && !this.selectSite) {
            this.service.listDocuments(this.path, 0, 50 )
               .subscribe(
                  (data: ListDocumentResponse) => {
                     this.folders = data.items.map(item => ({
                        ...item,
                        selected: false
                     }));
                     if (data.metadata.itemCounts.documents > 0 && data.metadata.itemCounts.folders < 1){
                        this.checkSubFolder.emit(true);
                     }
                     this.setAnimationState();
                  }, error => {
                     this.error = error;
                  }).add(() => {
               this.loading = false;
            });
         }
         if (this.selectFile && this.selectSite) {
            this.service.listDocuments_business(this.path, 0, 50,this.tin)
               .subscribe(
                  (data: ListDocumentResponse) => {
                     this.folders = data.items.map(item => ({
                        ...item,
                        selected: false
                     }));
                     if (data.metadata.itemCounts.documents > 0 && data.metadata.itemCounts.folders < 1){
                        this.checkSubFolder.emit(true);
                     }
                     this.setAnimationState();
                  }, error => {
                     this.error = error;
                  }).add(() => {
               this.loading = false;
            });
         }
      }

   }

   setAnimationState(){
      setTimeout(() => {
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      }, 100);
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   getFragment(name: string): string {
      return this.path ? this.path + '/' + name : name;
   }

   navigate(name: string, sub: FoldersComponent) {
      if (!sub.isExpanded()) {
         sub.toggle();
      }
      const url = this.tin ? Path.combine('/work', this.tin, encodeURIComponent(this.path),
         encodeURIComponent(name)) : Path.combine('/files', encodeURIComponent(this.path), encodeURIComponent(name));
      this.router.navigate([url]);
   }

   select(name: any, sub: any) {
      if(this.selectFile || this.exportPath || this.move || ((name.permissions.write|| name.isFolder) && ((!name.startFlow && name.statusDocument === '') || name.statusDocument === 'Completed'))) {
         $('.selectedPath').removeClass('selectedPath');
         $('#move' + name.id).addClass('selectedPath');
         if (!sub.isExpanded()) {
            sub.toggle();
         }
         if (this.selectedItem === sub) {
            return;
         }
         if (this.selectedItem) {
            this.selectedItem.selected = false;
         }
         this.selectedItem = sub;
         sub.selected = true;
      }
   }

   onSelectPath(agreed: any) {
      if((((agreed.permissions.write|| agreed.isFolder) && ((!agreed.startFlow && agreed.statusDocument === '') || agreed.statusDocument === 'Completed')) || !this.selectFile) || this.exportPath) {
         this.selectPath.emit(agreed);
         this.isSelect=true;
      } else{
         this.isSelect=false;
      }
   }

   unCheck() {
      let folder = false;
      for(let i of this.folders){
         if(i.selected){
            folder = true;
            break;
         }
      }
      if(!folder){
         const folderSelect = document.getElementById("chk_"+this.checkFolder) as HTMLInputElement;
         folderSelect.click();
      }
   }

   onGetPath(name) {
      this.getPath.emit(this.parentPath + name);
   }

   onFolder(checkSubFolder , item:any){
      item.subFolder = checkSubFolder;
   }

   getValidateExtension(item:any):boolean{
      if (item) {
         return Mimetype.validateExtension(item, this.typeName);
      } else {
         return true;
      }
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   selectFiles(event: MouseEvent, item: FolderItem , sub: FoldersComponent , type: 'check' | 'name') {
      if(!item.isFolder && (this.getValidateExtension(item.mimeType))) { // สำหรับ Checkbox File
         if((item.permissions.write|| item.isFolder) && ((!item.startFlow && item.statusDocument === '') || item.statusDocument === 'Completed')) {
            item.selected = !item.selected;
            const index = this.selectedItems.map(e => e.id).indexOf(item.id);
            if (item.selected) {
               if (index === -1) {
                  item.uploadType = 'zDox';
                  this.selectedItems.push(item);
               }
            } else {
               if (index !== -1) {
                  this.selectedItems.splice(index, 1);
               }
            }
            if (this.checkFolder) {
               this.unCheck();
            }
         }
      } else if(item.isFolder) { // สำหรับ Checkbox Folder
         event.preventDefault();
         if (item.permissions.write && item.subFolder) {
            let delay = 0;
            if (!sub.isExpanded()) {
               delay = 250; // Set delay ให้ Toggle ก่อนจึวจะเห็น Checkbox
            }
            if(type === 'check' && !sub.isExpanded()){
               sub.toggle();
            }
            if(type === 'check'){
               item.selected = !item.selected;
               if(item.selected){
                  this.checkFolder = item.id;
               } else {
                  this.checkFolder = null;
               }
            }
            setTimeout(() => {
               if (sub.folders) {
                  for (let i of sub.folders) {
                     if (!i.isFolder && this.getValidateExtension(i.mimeType)) {
                        if((i.permissions.write|| i.isFolder) && ((!i.startFlow && i.statusDocument === '') || i.statusDocument === 'Completed')) {
                           i.selected = item.selected;
                           const index = this.selectedItems.map(e => e.id).indexOf(i.id);
                           if (i.selected) {
                              if (index === -1) {
                                 i.uploadType = 'zDox';
                                 this.selectedItems.push(i);
                              }
                           } else {
                              if (index !== -1 || !index) {
                                 this.selectedItems.splice(index, 1);
                              }
                           }
                        }
                     }
                  }
               }
            }, delay);
         }
      }
   }
}
